import React, { useEffect, useState } from "react";
import {
  PanelBar,
  PanelBarItem,
  Menu,
  MenuItem,
} from "@progress/kendo-react-layout";
import {
  MDBContainer,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBCol,
  MDBRow,
  MDBCard,
  MDBCardHeader,
  MDBCardBody,
} from "mdbreact";
import CarrierContact from "./CarrierContact/CarrierContact";
import {
  getCarrierContactTableDetails,
  getCarrierMasterTableDetails,
  getCurrencyDetails,
} from "./CarrierMasterService";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import CarrierContactTable from "./CarrierContact/CarrierContactTable";
import { FormProvider } from "./CarrierContact/FormContext";
import CarrierMasterSearch from "./CarrierMasterPage/CarrierMasterSearch";
import CarrierMasterTable from "./CarrierMasterPage/CarrierMasterTable";
import BlockUi from '@availity/block-ui';
import {Circles} from "react-loader-spinner";

import "./CarrierMaster.scss";

function CarrierMaster() {
  const [menuIndex, setMenuIndex] = useState("0");
  const [tableData, setTableData] = useState(null);
  const [cmTableData, setCmTableData] = useState(null);
  const [currencyData, setCurrencyData] = useState(null);
  const [ddData, setDdData] = useState({
    region: null,
    country: null,
    scac: null,
    opssegment: null,
    transportationMode: null,
  });
  const [blocking, setBlocking] = useState(true);

  useEffect(() => {
    const tempData = { text: "ALL", value: "all" };
    onSearchClickCM(tempData);
  }, []);

  useEffect(() => {
    if (
      ddData["region"] &&
      ddData["country"] &&
      ddData["scac"] &&
      ddData["opssegment"] &&
      ddData["transportationMode"] &&
      currencyData
    ) {
      setBlocking(false);
    }
  }, [ddData, currencyData]);

  const handleMenuClick = (event) => {
    //console.log(event);
    setMenuIndex(event);
  };

  const onSearchClick = async (data) => {
    const response = await getCarrierContactTableDetails(data);
    console.log(response);
    if (response["status"][0]["status"] === "Success") {
      setTableData(response["searchInput"]);
    } else {
      setTableData([]);
    }
  };

  const onSearchClickCM = async (data) => {
    //console.log(data)
    const tempCMTableData = await getCarrierMasterTableDetails(data["text"]);
    //console.log(tempCMTableData)
    setCmTableData(tempCMTableData);

    let tempCurrencyData = await getCurrencyDetails();
    tempCurrencyData = tempCurrencyData.map((d) => d["value"]);
    setCurrencyData(tempCurrencyData);
  };

  return (
    <div className="carrier-master" style={{marginTop:"-4px"}}>
      <BlockUi  
        tag="div"
        blocking={blocking}
        loader={
          <Circles
            color="#00BFFF"
            height="100"
            width="100"
            timeout="6000" //3 secs
        />
        }
      >
        <MDBContainer fluid>
          <MDBRow>
            <MDBCol sm="12" className="titleBox">
              <label>
                {menuIndex === "0" ? "Carrier Master" : "Carrier Contact"}
              </label>
            </MDBCol>
          </MDBRow>
        </MDBContainer>

        <div className="container-fluid carrier-master-card">
          <MDBRow className="carrier-master-card-row">
            <MDBCard className="cc-card" style={{border: "1px solid #0071c5 !important"}}>
              <MDBCardHeader className="cc-card-header"></MDBCardHeader>
              <MDBCardBody>
                {/* <MDBNav className="nav-tabs mt-1">
                  <MDBNavItem>
                    {/* <MDBNavLink
                      link
                      to="#"
                      active={menuIndex === "0"}
                      onClick={() => {
                        handleMenuClick("0");
                      }}
                      role="tab"
                      className="cc-nav-links"
                    >
                      Carrier Master
                    </MDBNavLink> 
                  </MDBNavItem>
                  <MDBNavItem>
                    {/* <MDBNavLink
                      link
                      to="#"
                      active={menuIndex === "1"}
                      onClick={() => {
                        handleMenuClick("1");
                      }}
                      role="tab"
                      className="cc-nav-links"
                    >
                      Carrier Contact for NCRM
                    </MDBNavLink> 
                  </MDBNavItem>
                </MDBNav> */}
                     <ul className="nav nav-tabs">
                     <li className="GDdisabled">
                      <a
                        data-toggle="tab"
                        className="active"
                        active={menuIndex === "0"}
                        onClick={() => {
                          handleMenuClick("0");
                        }}
                      >
                       Carrier Master
                      </a>
                      </li>
                      <li className="GDdisabled">
                      <a
                        data-toggle="tab"
                        className="active"
                        active={menuIndex === "1"}
                        onClick={() => {
                          handleMenuClick("1");
                        }}
                      >
                       Carrier Contact for NCRM
                      </a>
                      </li>
                      </ul>
                <MDBTabContent activeItem={menuIndex} className="ml-4">
                  <MDBTabPane tabId="0" role="tabpanel">
                    <CarrierMasterSearch onSearchClickCM={onSearchClickCM} />
                  </MDBTabPane>
                  <MDBTabPane tabId="1" role="tabpanel">
                    <CarrierContact
                      onSearchClick={onSearchClick}
                      ddData={ddData}
                      setDdData={setDdData}
                    />
                  </MDBTabPane>
                </MDBTabContent>
              </MDBCardBody>
            </MDBCard>
          </MDBRow>
        </div>

        <div className="container-fluid carrier-master-card">
          {tableData && menuIndex === "1" && (
            <MDBRow style={{ paddingBottom: "50px", justifyContent: "center" }}>
              <FormProvider>
                <CarrierContactTable
                  tableData={tableData}
                  ddData={ddData}
                  onSearchClick={onSearchClick}
                />
              </FormProvider>
            </MDBRow>
          )}
          {cmTableData && currencyData && menuIndex === "0" && (
            <MDBRow style={{ paddingBottom: "50px", justifyContent: "center" }}>
              <>
                <CarrierMasterTable
                  cmTableData={cmTableData}
                  onSearchClickCM={onSearchClickCM}
                  currencyData={currencyData}
                />
                {/* <div>
              <pre>{JSON.stringify(cmTableData, null, 2)}</pre>
            </div> */}
              </>
            </MDBRow>
          )}
        </div>
        {/* <div><pre>{JSON.stringify(tableData, null, 2) }</pre></div> */}
      </BlockUi>
    </div>
  );
}

export default CarrierMaster;
